export const states = [
  ['AL', 'Alabama'],
  ['AK', 'Alaska'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['DC', 'District of Columbia'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['HI', 'Hawaii'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['ME', 'Maine'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NE', 'Nebraska'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['ND', 'North Dakota'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['SD', 'South Dakota'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
];

export const userTypes = [
  { id: 'User', label: 'User' },
  { id: 'Admin', label: 'Admin' },
  { id: 'SuperAdmin', label: 'SuperAdmin' },
];

export const teamColors = ['#157b71', '#30616b', '#608d60', '#7f4d3c', '#88a0a9', '#949f50', '#966693', '#accdcb', '#b07e52', '#b35e53', '#d1aa53', '#db97e4', '#ee9183', '#f5c4b4', '#f9fa61'];
export const teamIcons = ['atom-alt', 'backpack', 'balance-scale', 'book', 'bullhorn', 'bullseye-arrow', 'calculator', 'car', 'cash-register', 'chart-pie', 'cog', 'crosshairs', 'cube', 'dollar-sign', 'draw-circle', 'flask', 'flower-tulip', 'gem', 'gift', 'globe', 'globe-asia', 'heart', 'heart-rate', 'ice-cream', 'industry', 'key', 'leaf', 'lightbulb', 'microphone', 'microscope', 'palette', 'paper-plane', 'paperclip', 'phone', 'podium', 'puzzle-piece', 'sack-dollar', 'seedling', 'share-alt', 'shield-alt', 'shopping-bag', 'shopping-cart', 'sitemap', 'suitcase-rolling', 'tire', 'train', 'truck', 'user-friends', 'wallet', 'warehouse-alt'];

export const meetingTypes = [
  { id: 'Open', label: 'Open' },
  { id: 'OneTime', label: 'One Time' },
];
